import script from "./GodBullIRL.vue?vue&type=script&setup=true&lang=js"
export * from "./GodBullIRL.vue?vue&type=script&setup=true&lang=js"

import "./GodBullIRL.vue?vue&type=style&index=0&id=a9e5d588&lang=scss"

const __exports__ = script;

export default __exports__